<template>
  <v-card
    variant="flat"
    :loading="loading ? 'primary' : false"
    class="d-flex flex-row flex-grow-0 align-center justify-space-between transparent-card pa-2 mb-2"
  >
    <sf-text ref="orderStatus" color="primary" class="flex-grow-1">
      {{ $t('orderStatus.' + orderStatus) }}
    </sf-text>
    <v-badge
      v-if="!loading"
      ref="countBadge"
      inline
      :content="count.toString()"
      :color="badgeColor"
    />
  </v-card>
</template>

<script setup lang="ts">
import SfText from '@/components/text/SfText.vue'
import { PortalOrderStatus } from '@/types/index'
import { PropType } from 'vue'

defineProps({
  orderStatus: {
    type: String as PropType<PortalOrderStatus>,
    required: true
  },
  count: {
    type: Number,
    required: true
  },
  loading: {
    type: Boolean,
    required: true
  },
  badgeColor: {
    type: String,
    default: 'primary'
  }
})
</script>
